// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Switzerland */
const CH = /^(?:(?:6[89]|7[235-9])\d{7})$/;

export default CH;
